<template>
  <v-main>
    <v-container>
      <v-toolbar class="elevation-0">
        <v-toolbar-title class="pl-0 ml-n4">{{ (id) ? 'Atualizar' : 'Adicionar' }} {{ (isPaidValue) ? 'Valor Pago' : 'Fatura' }}</v-toolbar-title>
      </v-toolbar>
      <v-alert type="error" v-if="errorMessage" class="mb-6">{{ errorMessage }}</v-alert>
      <v-form ref="form" @submit.prevent>
        <v-row>
          <v-col cols="12" md="12" class="pb-0">
            <v-autocomplete
              label="Turma"
              v-model="additional_info.celebration.value"
              :rules="[...additional_info.celebration.rules]"
              :items="additional_info.celebration.options"
              :loading="additional_info.celebration.loading"
              :search-input.sync="additional_info.celebration.search"
              :placeholder="($route.query.customer) ? 'Selecione uma turma' : 'Comece escrevendo o nome da turma'"
              :disabled="(id || ($route.query && $route.query.celebration)) ? true : false"
              hide-no-data no-filter
              outlined dense
              @input="getParticipantSelect()"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="6" class="pb-0">
            <v-autocomplete
              label="Participante"
              v-model="additional_info.participant.value"
              :rules="[...additional_info.participant.rules]"
              :items="additional_info.participant.options"
              :loading="additional_info.participant.loading"
              :search-input.sync="additional_info.participant.search"
              :disabled="(id || !additional_info.celebration.value || ($route.query && $route.query.customer)) ? true : false"
              :placeholder="(additional_info.celebration.value) ? 'Selecione um participante' : 'Escolha uma turma primeiro...'"
              outlined dense
              @input="getJoinedSelect()"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" xs="6" md="3" class="pb-0">
            <v-menu
              ref="invoice_date_menu"
              v-model="fields.invoice_date.menu"
              :close-on-content-click="false"
              :return-value.sync="fields.invoice_date.value"
              transition="scale-transition"
              offset-y min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  label="Competência"
                  :value="(fields.invoice_date.value) ? $moment(fields.invoice_date.value, 'YYYY-MM').format('MM/YYYY') : fields.invoice_date.value"
                  :rules="[...fields.invoice_date.rules, ...fields.invoice_date.apiErrors]"
                  type="text"
                  prepend-inner-icon="mdi-calendar-blank"
                  readonly
                  @input="fields.invoice_date.apiErrors = []"
                  v-on="on"
                  outlined dense
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="fields.invoice_date.value"
                no-title scrollable
                type="month"
                locale="pt-br"
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="fields.invoice_date.menu = false">Cancelar</v-btn>
                <v-btn text color="primary" @click="$refs.invoice_date_menu.save(fields.invoice_date.value)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" xs="6" md="3" class="pb-0">
            <v-menu
              ref="due_date_menu"
              v-model="fields.due_date.menu"
              :close-on-content-click="false"
              :return-value.sync="fields.due_date.value"
              transition="scale-transition"
              offset-y min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :label="(isPaidValue) ? 'Pagamento' : 'Vencimento'"
                  :value="(fields.due_date.value) ? $moment(fields.due_date.value, 'YYYY-MM-DD').format('DD/MM/YYYY') : fields.due_date.value"
                  :rules="[...fields.due_date.rules, ...fields.due_date.apiErrors]"
                  type="text"
                  prepend-inner-icon="mdi-calendar-blank"
                  readonly
                  @input="fields.due_date.apiErrors = []"
                  v-on="on"
                  outlined dense
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="fields.due_date.value"
                no-title scrollable
                locale="pt-br"
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="fields.due_date.menu = false">Cancelar</v-btn>
                <v-btn text color="primary" @click="$refs.due_date_menu.save(fields.due_date.value)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0">
            <h3 class="title">Itens</h3>
            <v-btn text color="primary" @click="addItem()" :disabled="(!id && !additional_info.participant.value)">
              <v-icon left>mdi-plus-circle-outline</v-icon> Adicionar item
            </v-btn>
            <template v-for="(item, index) in fields.items.value">
              <v-divider class="my-4" :key="'divider' + index" />
              <v-row :key="'title' + index">
                <v-col class="subtitle-2">
                  {{ (item.id) ? item.description : 'Novo Item' }}
                </v-col>
                <v-col class="subtitle-2 text-right">
                  <v-btn @click="deleteItem(item.id, index)" color="error" :fab="$vuetify.breakpoint.name === 'xs'" text small dark>
                    <v-icon>mdi-delete</v-icon> <template v-if="$vuetify.breakpoint.name !== 'xs'">Excluir</template>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row :key="index">
                <v-col v-if="item.category === 'fundraising' && !item.id" cols="12">
                  <v-alert type="warning" class="mb-6">Esse tipo de categoria vai remover uma parcela do cliente. É isso mesmo?</v-alert>
                </v-col>
                <v-col cols="12" sm="4" md="3" class="pb-0">
                  <v-autocomplete
                    label="Categoria"
                    v-model="item.category"
                    :rules="[...fields.items.rules.category, ...fields.items.apiErrors[index].category]"
                    :items="fields.items.options.category"
                    :loading="fields.items.loading.category"
                    :disabled="(!additional_info.participant.value)"
                    @input="getDescription(index)"
                    outlined dense
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="8" md="9" class="pb-0">
                  <v-autocomplete
                    label="Arrecadação"
                    v-model="item.joined_id"
                    :rules="[...fields.items.rules.joined_id, ...fields.items.apiErrors[index].joined_id]"
                    :items="fields.items.options.joined_id"
                    :loading="fields.items.loading.joined_id"
                    :disabled="(!additional_info.participant.value)"
                    :placeholder="(additional_info.participant.value) ? 'Selecione uma arrecadação' : 'Escolha um participante primeiro...'"
                    @input="getDescription(index)"
                    outlined dense
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="8" md="9" class="pb-0">
                  <v-text-field
                    label="Descrição"
                    v-model="item.description"
                    :rules="[...fields.items.rules.description, ...fields.items.apiErrors[index].description]"
                    type="text"
                    :disabled="!additional_info.participant.value"
                    @input="fields.items.apiErrors.description = []"
                    outlined dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="3" class="pb-0">
                  <decimal-number
                    label="Valor"
                    v-model="item.installment_amount"
                    :rules="[...fields.items.apiErrors[index].installment_amount]"
                    :disabled="!additional_info.participant.value"
                    @input="fields.items.apiErrors.installment_amount = []"
                    outlined dense
                  ></decimal-number>
                </v-col>
              </v-row>
            </template>
          </v-col>
        </v-row>
        <v-btn color="success" :disabled="sending" :loading="sending" @click="send()">Salvar</v-btn>
        <v-btn text color="error" :disabled="sending" @click="$router.go(-1)">Cancelar</v-btn>
      </v-form>
    </v-container>
    <app-loading :visible="loading"></app-loading>
  </v-main>
</template>

<script>
import axios from 'axios'
import { mapMutations } from 'vuex'
import AppLoading from '@/components/Loading'
import DecimalNumber from '@/components/DecimalNumber'

export default {
  name: 'invoiceForm',
  components: {
    AppLoading,
    DecimalNumber
  },
  props: ['id'],
  data: () => ({
    loading: false,
    additional_info: {
      celebration: {
        value: '',
        options: [],
        search: '',
        timeout: null,
        loading: false,
        rules: [
          v => !!v || 'A turma é obrigatória'
        ]
      },
      participant: {
        value: '',
        options: [],
        search: '',
        timeout: null,
        loading: false,
        rules: [
          v => !!v || 'O participante é obrigatório'
        ]
      },
      customer_name: ''
    },
    fields: {
      invoice_date: {
        value: null,
        menu: false,
        rules: [
          v => !!v || 'A competência é obrigatória'
        ],
        apiErrors: []
      },
      due_date: {
        value: null,
        menu: false,
        rules: [
          v => !!v || 'A data é obrigatória'
        ],
        apiErrors: []
      },
      items: {
        value: [
          {
            id: null,
            joined_id: '',
            category: null,
            description: '',
            installment_amount: null,
            notes: ''
          }
        ],
        options: {
          joined_id: [],
          category: [
            { value: 'fundraising', text: 'Parcela' },
            { value: 'interest_and_fines', text: 'Multa/juros' },
            { value: 'renegotiation', text: 'Renegociação' },
            { value: 'additional', text: 'Adicional' },
            { value: 'discount', text: 'Desconto' }
          ]
        },
        loading: {
          joined_id: false
        },
        rules: {
          category: [
            v => !!v || 'A categoria é obrigatória'
          ],
          joined_id: [
            v => !!v || 'A arrecadação é obrigatória'
          ],
          description: [
            v => !!v || 'A descrição é obrigatória'
          ],
          installment_amount: [
            v => !!v || 'O valor é obrigatório'
          ]
        },
        apiErrors: [
          {
            id: [],
            joined_id: [],
            category: [],
            description: [],
            installment_amount: [],
            notes: []
          }
        ]
      }
    },
    itemsToDelete: [],
    sending: false,
    errorMessage: null
  }),
  computed: {
    apiData () {
      let data = {}
      for (let key in this.fields) {
        if (key !== 'celebration' && key !== 'participant') {
          if (key === 'invoice_date') data[key] = (this.fields[key].value.length > 7) ? this.fields[key].value : this.fields[key].value + '-01'
          else if (key === 'items') {
            if (!this.id) {
              data.items = this.fields[key].value.map(e => ({
                category: e.category,
                joined_id: e.joined_id,
                description: e.description,
                installment_amount: e.installment_amount
              }))
            }
          } else if (this.fields[key].value) data[key] = this.fields[key].value
        }
      }
      if (this.isPaidValue) data.payment_date = this.fields.due_date.value
      return data
    },
    isPaidValue () {
      return this.$route.query && this.$route.query.type === 'paid'
    }
  },
  watch: {
    'additional_info.celebration.search' (val) {
      if (this.additional_info.celebration.timeout) {
        clearTimeout(this.additional_info.celebration.timeout)
      }

      this.additional_info.celebration.timeout = setTimeout(() => {
        this.getCelebrationSelect(val)
      }, 500)
    },
    'additional_info.participant.search' (val) {
      if (this.additional_info.participant.timeout) {
        clearTimeout(this.additional_info.participant.timeout)
      }

      this.additional_info.participant.timeout = setTimeout(() => {
        this.getParticipantSelect(val)
      }, 500)
    }
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    generateApiErrors (apiErrors) {
      for (let key in apiErrors) {
        if (key.split('.').length > 1) {
          let keys = key.split('.')
          if (this.fields[keys[0]]) this.fields[keys[0]].apiErrors[keys[1]][keys[2]] = apiErrors[key]
        } else if (this.fields[key]) this.fields[key].apiErrors = apiErrors[key]
      }
    },
    addItem () {
      this.fields.items.value.push({
        id: null,
        joined_id: '',
        category: null,
        description: '',
        installment_amount: null,
        notes: ''
      })
      this.addItemApiErrors()
    },
    addItemApiErrors () {
      this.fields.items.apiErrors.push({
        id: [],
        joined_id: [],
        category: [],
        description: [],
        installment_amount: [],
        notes: []
      })
    },
    deleteItem (id, index) {
      if (id) this.itemsToDelete.push(id)
      this.fields.items.value.splice(index, 1)
    },
    getDescription (index) {
      let fundraising = this.fields.items.options.joined_id.filter(e => e.value === this.fields.items.value[index].joined_id)[0]
      if (!this.fields.items.value[index].description) {
        if (this.fields.items.value[index].category === 'fundraising' && fundraising) this.fields.items.value[index].description = fundraising.text
        if (this.fields.items.value[index].category === 'interest_and_fines') this.fields.items.value[index].description = 'Multa/juros'
      }
    },
    getCelebrationSelect (val) {
      if (!this.id && !this.$route.query.customer && !this.$route.query.celebration) {
        this.additional_info.celebration.loading = true
        axios.get('celebrations', {
          params: {
            'filter[activate]': true,
            'filter[name]': val
          }
        })
          .then(response => {
            this.additional_info.celebration.options = response.data.data.map(e => ({
              value: e.id,
              text: e.name
            }))
          })
          .finally(() => (this.additional_info.celebration.loading = false))
      }
    },
    getParticipantSelect (val) {
      if (!this.id) {
        if (this.$route.query.customer) {
          let participantIndex = this.additional_info.participant.options.filter(e => e.celebration === this.additional_info.celebration.value)
          if (participantIndex.length > 0) {
            this.additional_info.participant.value = participantIndex[0].value
          }
          this.getJoinedSelect()
        } else {
          this.additional_info.participant.loading = true
          let endpoint = 'participants?filter[celebration_id]=' + this.additional_info.celebration.value
          if (val) endpoint += '&filter[q]=' + val
          axios.get(endpoint)
            .then(response => {
              this.additional_info.participant.options = response.data.data.map(e => ({
                value: e.id,
                text: e.customer.name
              }))
            })
            .finally(() => (this.additional_info.participant.loading = false))
        }
      }
    },
    getJoinedSelect () {
      if (this.additional_info.participant.value) {
        this.fields.items.loading.joined_id = true
        axios.get('participants/' + this.additional_info.participant.value)
          .then(response => {
            this.fields.items.options.joined_id = response.data.fundraisings.map(e => ({
              value: e.joined_id,
              text: e.name
            }))
          })
          .finally(() => (this.fields.items.loading.joined_id = false))
      }
    },
    send () {
      let vue = this

      if (vue.$refs.form.validate()) {
        vue.sending = true
        vue.errorMessage = null

        let endpoint = (vue.id) ? 'invoices/' + vue.id : 'invoices'

        if (vue.isPaidValue) {
          endpoint = 'invoices/paid/third-parties'
        }

        axios(endpoint, {
          method: (vue.id) ? 'patch' : 'post',
          data: vue.apiData
        })
          .then(response => {
            if (!vue.id) {
              vue.sending = false
              vue.SET_SNACKBAR({ text: (vue.id) ? 'Fatura atualizada' : 'Fatura adicionada' })
              vue.$router.go(-1)
            } else {
              vue.sendItems()
            }
          })
          .catch(error => {
            if (error.response && error.response.status === 422) {
              if (error.response.data) vue.generateApiErrors(error.response.data)
              vue.errorMessage = 'Verifique os campos com erro'
            } else {
              vue.errorMessage = 'Houve um erro ao processar seu pedido, por favor contacte o suporte técnico'
            }
            vue.sending = false
          })
      } else {
        vue.errorMessage = 'Verifique os campos com erro'
      }
    },
    async sendItems () {
      try {
        for (let i = 0, l = this.itemsToDelete.length; i < l; i++) {
          await axios.delete('invoice-items/' + this.itemsToDelete[i] + '?invoice_id=' + this.id)
        }
        for (let i = 0, l = this.fields.items.value.length; i < l; i++) {
          let item = this.fields.items.value[i]
          let endpoint = ((item.id) ? 'invoice-items/' + item.id : 'invoice-items') + '?invoice_id=' + this.id
          let method = (item.id) ? 'patch' : 'post'
          let data = {
            category: item.category,
            joined_id: item.joined_id,
            description: item.description,
            installment_amount: item.installment_amount
          }
          await axios(endpoint, { method, data })
        }
        this.sending = false
        this.SET_SNACKBAR({ text: (this.id) ? 'Fatura atualizada' : 'Fatura adicionada' })
        this.$router.go(-1)
      } catch (error) {
        this.errorMessage = 'Houve um erro ao tentar editar a fatura, por favor atualize a página e tente novamente'
        this.sending = false
      }
    }
  },
  created () {
    let vue = this

    if (this.id) {
      vue.loading = true

      axios.get('invoices/' + vue.id)
        .then(response => {
          if (response.data) {
            vue.loading = false
            vue.additional_info.celebration.value = response.data.celebration.id
            vue.additional_info.celebration.options = [{ value: response.data.celebration.id, text: response.data.celebration.name }]
            vue.additional_info.participant.value = response.data.participant.id
            vue.additional_info.participant.options = [{ value: response.data.participant.id, text: response.data.customer.name }]
            vue.getJoinedSelect()
            for (let key in vue.fields) {
              if (key === 'items' && response.data.items.length > 1) for (let i = 0, l = response.data.items.length; i < l; i++) vue.addItemApiErrors()
              if (response.data[key]) vue.fields[key].value = response.data[key]
            }
          } else {
            vue.loading = false
            vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
            vue.$router.go(-1)
          }
        })
        .catch(() => {
          vue.loading = false
          vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
          vue.$router.go(-1)
        })
    } else if (vue.$route.query.celebration || vue.$route.query.customer) {
      vue.loading = true

      let endpoint = 'participants?'
      if (vue.$route.query.celebration) endpoint += 'filter[celebration_id]=' + vue.$route.query.celebration
      if (vue.$route.query.celebration && vue.$route.query.customer) endpoint += '&'
      if (vue.$route.query.customer) endpoint += 'filter[customer_id]=' + vue.$route.query.customer

      axios.get(endpoint)
        .then(response => {
          if (response.data && response.data.data) {
            if (response.data.data.length === 1 || (vue.$route.query.celebration && vue.$route.query.customer)) {
              vue.additional_info.celebration.value = response.data.data[0].celebration.id
              vue.additional_info.celebration.options = [{ value: response.data.data[0].celebration.id, text: response.data.data[0].celebration.name }]
              vue.additional_info.participant.value = response.data.data[0].id
              vue.additional_info.participant.options = [{ value: response.data.data[0].id, text: response.data.data[0].customer.name }]
              vue.getJoinedSelect()
            } else {
              vue.additional_info.participant.options = response.data.data.map(e => ({
                value: e.id,
                text: e.customer.name,
                celebration: e.celebration.id
              }))
              if (vue.$route.query.celebration) {
                vue.additional_info.celebration.value = response.data.data[0].celebration.id
                vue.additional_info.celebration.options = [{ value: response.data.data[0].celebration.id, text: response.data.data[0].celebration.name }]
                vue.getParticipantSelect()
              } else {
                vue.additional_info.celebration.options = response.data.data.map(e => ({
                  value: e.celebration.id,
                  text: e.celebration.name
                }))
              }
            }
          }
        })
        .finally(() => (vue.loading = false))
    }
  }
}
</script>
